module.exports = __webpack_public_path__ + "static/images/broken-link.svg";